import { render, staticRenderFns } from "./AppLoading.vue?vue&type=template&id=241e87fa&scoped=true&"
import script from "./AppLoading.vue?vue&type=script&lang=ts&"
export * from "./AppLoading.vue?vue&type=script&lang=ts&"
import style0 from "./AppLoading.vue?vue&type=style&index=0&id=241e87fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241e87fa",
  null
  
)

export default component.exports